'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = require('../../module');

var _module3 = _interopRequireDefault(_module2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var WinresShoppingCartModal = function () {
    function WinresShoppingCartModal($element, $scope, $uibModal, $transclude) {
        _classCallCheck(this, WinresShoppingCartModal);

        this.$element = $element;
        this.$scope = $scope;
        this.$uibModal = $uibModal;
        this.$transclude = $transclude;
        this.modal = null;
    }

    _createClass(WinresShoppingCartModal, [{
        key: '$onInit',
        value: function $onInit() {
            // Blatant hack to enable opening/closing shopping cart from WordPress.
            // Replaces existing shopping cart functions.
            window.showShoppingBasket = this.openModal.bind(this);
            window.closeShoppingBasket = this.closeModal.bind(this);
        }
    }, {
        key: 'openModal',
        value: function openModal() {
            var _this = this;

            // Close already opened modal.
            this.closeModal();

            this.modal = this.$uibModal.open({
                resolve: {
                    // This function can be called to get a copy of this element's contents.
                    // The popup controller uses it to insert the contents within the popup.
                    transcludeFunc: function transcludeFunc() {
                        return _this.$transclude;
                    },
                    context: function context() {
                        return _this.context;
                    }
                },

                component: 'winresShoppingCartModalPopup',

                // Append the modal element to this element.
                // Without this, the modal element gets appended to <body>, and components
                // that use "require: '^^winresReservationContext'" will not work within the modal
                // since they can't find the enclosing <winres-reservation-context> element.
                // However, this doesn't matter if we just pass the context as a parameter.
                // If we do that, we can append to body without problems.
                // In that case, set appendToBody.
                appendTo: this.appendToBody === 'true' ? undefined : this.$element,

                // Large modal width.
                size: 'lg'
            });
        }
    }, {
        key: 'closeModal',
        value: function closeModal() {
            if (this.modal) {
                this.modal.close();
                this.modal = null;
            }
        }
    }]);

    return WinresShoppingCartModal;
}();

WinresShoppingCartModal.$inject = ['$element', '$scope', '$uibModal', '$transclude'];

_module3.default.component('winresShoppingCartModal', {
    template: '',
    controller: WinresShoppingCartModal,
    transclude: true,
    require: {
        context: '^^winresReservationContext'
    },
    bindings: {
        appendToBody: '@'
    }
});

var WinresShoppingCartModalPopup = function () {
    function WinresShoppingCartModalPopup($element) {
        _classCallCheck(this, WinresShoppingCartModalPopup);

        this.$element = $element;
        this.transcludedContent = null;
        this.transclusionScope = null;
    }

    _createClass(WinresShoppingCartModalPopup, [{
        key: '$onInit',
        value: function $onInit() {}
    }, {
        key: '$postLink',
        value: function $postLink() {
            var _this2 = this;

            // Transclude the contents within the popup.
            var transcludeTarget = this.$element.find('.transclude-target');

            this.resolve.transcludeFunc(function (clone, scope) {
                transcludeTarget.append(clone);
                _this2.transcludedContent = clone;
                _this2.transclusionScope = scope;
            });
        }
    }, {
        key: '$onDestroy',
        value: function $onDestroy() {
            this.transcludedContent.remove();
            this.transclusionScope.$destroy();
        }
    }, {
        key: 'closeModal',
        value: function closeModal() {
            this.close();
        }
    }]);

    return WinresShoppingCartModalPopup;
}();

WinresShoppingCartModalPopup.$inject = ['$element'];

_module3.default.component('winresShoppingCartModalPopup', {
    template: require('./winresShoppingCartModalPopup.html'),
    controller: WinresShoppingCartModalPopup,
    bindings: {
        close: '&',
        dismiss: '&',
        modalInstance: '<',
        resolve: '<'
    }
});


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresShoppingCartModal/winresShoppingCartModal.js
// module id = 510
// module chunks = 2